/**
 * El ancho del menú lateral: expandido o compacto.
 *
 * Sin lógica de React, para poder probarla con el ejecutor de Node, igual que
 * el tema. Compacto deja solo la columna de íconos y le devuelve al contenido
 * unos once rem; es una comodidad de pantalla ancha, así que en un teléfono,
 * donde el menú ya es un cajón, no aplica.
 *
 * Parte **expandido** y solo recuerda la elección de achicarlo: quien entra
 * por primera vez necesita ver los nombres, y quien lo achicó lo hizo porque
 * ya sabe dónde está cada cosa.
 */

export type Lateral = 'expandido' | 'compacto';

export const CLAVE_LATERAL = 'vox.lateral';

/** Lo que hay guardado, o `expandido` si no hay nada o el almacenamiento falla. */
export function leerLateral(almacen?: Pick<Storage, 'getItem'>): Lateral {
  try {
    return (almacen ?? localStorage).getItem(CLAVE_LATERAL) === 'compacto' ? 'compacto' : 'expandido';
  } catch {
    // Modo privado, datos de sitio bloqueados: el panel tiene que seguir
    // funcionando, solo que sin recordar la elección.
    return 'expandido';
  }
}

export function guardarLateral(lateral: Lateral, almacen?: Pick<Storage, 'setItem' | 'removeItem'>): void {
  try {
    const destino = almacen ?? localStorage;
    if (lateral === 'compacto') destino.setItem(CLAVE_LATERAL, 'compacto');
    else destino.removeItem(CLAVE_LATERAL);
  } catch {
    // Sin dónde guardar, la elección vale solo para esta sesión.
  }
}

export function alternarLateral(actual: Lateral): Lateral {
  return actual === 'compacto' ? 'expandido' : 'compacto';
}

export function aplicarLateral(
  lateral: Lateral,
  raiz: Pick<HTMLElement, 'setAttribute'> = document.documentElement
): void {
  raiz.setAttribute('data-lateral', lateral);
}

/** Las iniciales de un nombre, para cuando solo cabe una ficha: «Tricot» → «TR», «Casa Ley» → «CL». */
export function iniciales(nombre: string): string {
  const palabras = nombre.trim().split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return '?';
  if (palabras.length === 1) return palabras[0]!.slice(0, 2).toUpperCase();
  return (palabras[0]![0]! + palabras[1]![0]!).toUpperCase();
}
